function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/market_report.css";
import { useVuelidate } from "@vuelidate/core";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
import { createApp, defineAsyncComponent } from "vue";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore, useMetadataStore
//@ts-ignore
} from "@store/index";
import { mapState, mapActions, createPinia } from "pinia";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
//@ts-ignore
import RequestMrExampleForm from "@vueEntry/RequestMrExampleForm.vue";
var PAGE_ZOOMS;
(function (PAGE_ZOOMS) {
  // ENUM VENDITORE
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_DATI"] = 0] = "ZOOM_DATI";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_INSIGHTS"] = 1] = "ZOOM_INSIGHTS";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_BOUGHT_N_SOLD"] = 2] = "ZOOM_BOUGHT_N_SOLD";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_ANALYSES"] = 3] = "ZOOM_ANALYSES";
  // ENUM ACQUIRENTE
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_DATI_BUYER"] = 4] = "ZOOM_DATI_BUYER";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_BOUGHT_N_SOLD_BUYER"] = 5] = "ZOOM_BOUGHT_N_SOLD_BUYER";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_ESTIMATE_N_MANAGEMENT_BUYER"] = 6] = "ZOOM_ESTIMATE_N_MANAGEMENT_BUYER";
  PAGE_ZOOMS[PAGE_ZOOMS["ZOOM_INCOME_GENERATION_BUYER"] = 7] = "ZOOM_INCOME_GENERATION_BUYER";
})(PAGE_ZOOMS || (PAGE_ZOOMS = {}));
var marketReportApp = createApp({
  name: "MarketReport",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu: PublicUserMenu,
    BaseInput: BaseInput,
    BaseButton: BaseButton,
    RequestMrExampleForm: RequestMrExampleForm,
    //@ts-ignore
    "request-mr-example-modal": defineAsyncComponent(function () {
      return import("@vueEntry/Modals/RequestMrExampleModal.vue");
    })
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }), LanguageIcons),
  setup: function setup() {
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useBaseSnackbar = useBaseSnackbar(),
      showBaseSnackbar = _useBaseSnackbar.showBaseSnackbar,
      handleShowSnackbar = _useBaseSnackbar.handleShowSnackbar,
      baseSnackbarProps = _useBaseSnackbar.baseSnackbarProps;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    var _useBreakpoints = useBreakpoints(),
      isLarge = _useBreakpoints.isLarge;
    useTrustpilotWidget();
    return {
      v$: useVuelidate(),
      isLarge: isLarge,
      isAppBannerVisible: isAppBannerVisible,
      showBaseSnackbar: showBaseSnackbar,
      handleShowSnackbar: handleShowSnackbar,
      baseSnackbarProps: baseSnackbarProps,
      //useFirebaseMessaging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick
    };
  },
  data: function data() {
    return {
      isLoading: false,
      firstCountUpText: 0,
      secondCountUpText: 0,
      thirdCountUpText: 0,
      isSeller: null,
      mrZoom: null,
      requestModalOpenedOnce: false,
      showReportBtn: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    enumZooms: function enumZooms() {
      return PAGE_ZOOMS;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  watch: {
    showModal: function showModal(cur) {
      //Sending the event just once!
      if (cur === Modals.requestMrExample && !this.requestModalOpenedOnce) {
        sendGAEvent("mr_open_form", {
          event_location: "".concat(this.pageName, " - Modale Richiedi Report di esempio")
        });
        this.requestModalOpenedOnce = true;
      }
    }
  },
  created: function created() {
    this.initPublicUserMenu();
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.checkScroll);
    this.observerContainer("mr-rating1", 67);
    this.observerContainer("mr-rating2", 86);
  },
  methods: Object.assign(Object.assign({
    checkScroll: function checkScroll(mainElement, footerElement) {
      this.showReportBtn = window.scrollY > 50 && window.scrollY < 3300;
    },
    setMrZoom: function setMrZoom(isSeller) {
      this.mrZoom = null;
      this.isSeller = isSeller;
      if (isSeller) {
        this.$nextTick(function () {
          var _a;
          (_a = document.getElementById("mr-venditore-img")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        });
      } else {
        this.$nextTick(function () {
          var _a;
          (_a = document.getElementById("mr-acquirente-img")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        });
      }
    },
    setZoom: function setZoom(enumZooms) {
      this.mrZoom = enumZooms;
    },
    observerContainer: function observerContainer(observedItem, endNr, duration) {
      var _this = this;
      var target = document.getElementById(observedItem);
      if (!target) return;
      var observerTarget = target;
      if (target) {
        var callback = function callback(entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setTimeout(function () {
                _this.mrCountUp(endNr, observedItem, duration).then(function () {
                  observer.unobserve(observerTarget);
                });
              }, 500);
            }
          });
        };
        var observer = new IntersectionObserver(callback, this.observerOptions);
        observer.observe(target);
      }
    },
    mrCountUp: function mrCountUp(endNr, itemToCountup) {
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.5;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var animationDuration, frameDuration, totalFrames, easeOutQuad, countTo, frame, counter;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              animationDuration = duration * 1000;
              frameDuration = 1000 / 60;
              totalFrames = Math.round(animationDuration / frameDuration);
              easeOutQuad = function easeOutQuad(t) {
                return t * (2 - t);
              };
              countTo = endNr;
              frame = 0;
              try {
                counter = setInterval(function () {
                  frame++;
                  var progress = easeOutQuad(frame / totalFrames);
                  var currentCount = Math.round(countTo * progress);
                  if (_this2.textEl !== currentCount) {
                    switch (itemToCountup) {
                      case "mr-rating1":
                        _this2.firstCountUpText = currentCount;
                        break;
                      case "mr-rating2":
                        _this2.secondCountUpText = currentCount;
                        break;
                    }
                  }
                  if (frame === totalFrames) clearInterval(counter);
                }, frameDuration);
              } catch (err) {
                console.log(err);
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    },
    scrollDown: function scrollDown() {
      window.scrollBy(0, window.innerHeight);
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useModalStore, ["setShowModal"]))
});
marketReportApp.use(createPinia());
marketReportApp.mount("#market-report-main");